import React from "react";
import ReactModal from "react-modal";
import PropTypes from "prop-types";

ReactModal.defaultStyles.overlay.backgroundColor = "rgb(99, 99, 99, 0.75)";

const customStyles = {
  overlay: {
    zIndex: 9999,
  },
  content : {
    top                   : "50%",
    left                  : "50%",
    right                 : "auto",
    bottom                : "auto",
    marginRight           : "-50%",
    overflow              : "visible",
    transform             : "translate(-50%, -50%)",
    zIndex                : 10000,
  },
};

if (process.env.NODE_ENV !== "test") {
  ReactModal.setAppElement("#root");
} else {
  ReactModal.setAppElement(document.createElement("div"));
}

export const Modal = (props) => {
  const { children, isOpen, onRequestClose, ...restProps } = props;
  return (
    <ReactModal 
      style={customStyles} 
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      {...restProps} // eslint-disable-line react/jsx-props-no-spreading
    >
      {children}
    </ReactModal>
  );
};

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element.isRequired,
  ]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
}
